import { render, staticRenderFns } from "./StaffDashboardUser.vue?vue&type=template&id=5c17ac6c&scoped=true&"
import script from "./StaffDashboardUser.vue?vue&type=script&lang=js&"
export * from "./StaffDashboardUser.vue?vue&type=script&lang=js&"
import style0 from "./StaffDashboardUser.vue?vue&type=style&index=0&id=5c17ac6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c17ac6c",
  null
  
)

export default component.exports